import SocketHandler from "@shared/services/socket/socketHandler";
import React from "react";

export const SocketContext = React.createContext<
  | {
      socketHandler: SocketHandler;
    }
  | undefined
>(undefined);
